import useBaseWidget from '../../../hooks/useBaseWidget.js';
import useQuery from '../../../hooks/useQuery.js';
import useWidget from '../../../hooks/useWidget.js';
import useWidgetActionsReducer from '../../../hooks/useWidgetActionsReducer.js';
import useWidgetRef from '../../../hooks/useWidgetRef.js';
import useWidgetState from '../../../hooks/useWidgetState.js';
const contextReducer = (state) => state;
function useContentBlock(config) {
    const { rfkId, dispatch } = useBaseWidget();
    const control = useWidget();
    if (!control.isInitialized()) {
        control.initialize(config || {});
    }
    const { query, options, actions } = control;
    const state = useWidgetState();
    const queryResult = useQuery(query);
    const widgetRef = useWidgetRef();
    useWidgetActionsReducer(contextReducer, []);
    return { widgetRef, rfkId, state, queryResult, actions, options, dispatch, query };
}
export default useContentBlock;
